/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CassettePrinter } from './CassettePrinter';
import type { CliaCertificate } from './CliaCertificate';

export type LabStation = {
    readonly id?: number;
    readonly lab_id?: number;
    readonly cassette_printer?: CassettePrinter;
    readonly clia_certificate?: CliaCertificate;
    type: LabStation.type;
    name: string;
    description: string;
    readonly created_at?: string;
    readonly updated_at?: string;
}

export namespace LabStation {

    export enum type {
        RECEIVING = 'receiving',
        ACCESSIONING = 'accessioning',
        GROSSING = 'grossing',
        PROCESSING = 'processing',
        EMBEDDING = 'embedding',
        CUTTING = 'cutting',
        STAINING = 'staining',
        SCANNING = 'scanning',
        FRIDGE = 'fridge',
        SHIPPING = 'shipping',
        MANAGER = 'manager',
    }


}
